import { DocumentMagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchDocumentPreviewFullReport } from "../../api/api-methods";
import LibraryRequestMenuItem from "../LibraryRequests/LibraryRequestMenuItem";
import { libraryPreviewFullReportMenuLabel } from "../../utils/libraryPreviewFullReport";

export default function LibraryPreviewFullReportMenuItem({
  documentId,
  enabled,
  onUpdated,
}) {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: (allow) => patchDocumentPreviewFullReport(documentId, allow),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["allDocumentsList"] });
      onUpdated?.();
    },
  });

  return (
    <LibraryRequestMenuItem
      disabled={isPending}
      onClick={(event) => {
        event?.stopPropagation?.();
        mutate(!enabled);
      }}
    >
      <DocumentMagnifyingGlassIcon className="w-[16px] h-[16px]" />
      <span>{libraryPreviewFullReportMenuLabel(enabled)}</span>
    </LibraryRequestMenuItem>
  );
}
